module.exports = __webpack_public_path__ + "static/media/walmart_logo.2c58e039.png";